module.exports = __webpack_public_path__ + "static/media/cold-calling.85b061db.jpg";